
























import {Component, Vue, Prop} from 'vue-property-decorator';
import { tweakwiseTracker } from '../../../shared/tweakwise';
@Component({
  name: 'search-result-suggested-products',
})

export default class extends Vue {
  @Prop() private resultData: Array<object>;
  @Prop() private searchQuery: string;

  private isOnlyAvailableInStore(product): boolean {
    return product['is_only_available_in_store'];
  }

  private productImage(product: object, size: number): string {
    if (null !== product['default_image']) {
      return product['default_image'].placeholder_url.replace('{size}', size);
    }
    return '';
  }
  private getProductCategory(index){
    const category = this.resultData[index]['category_paths'][0];
    return category[category.length - 1].label;
  }

  private getUrl(product: object): string {
    if (this.searchQuery.length > 5 && /^\d+$/.test(this.searchQuery)) {
      return product['url'];
    }

    return `${product['url']}?q=${this.searchQuery}`;
  }
  private created(): void {
    this.tweakwisePageImpression();
  }
  private tweakwisePageImpression(): void {
    const itemIds: Array<string> = this.resultData.map((product: any) => product['tweakwise_item_id']);
    const requestId: string = this.resultData.length > 0 ? this.resultData[0]['tweakwise_request_id'] : '';

    tweakwiseTracker.trackPageImpression({
      requestId: requestId,
      itemIds: itemIds,
    });
  }
  private onProductClick(product): void {
    const itemId = product['tweakwise_item_id'];
    const requestId = product['tweakwise_request_id'];

    tweakwiseTracker.trackItemClick({
      requestId: requestId,
      itemId: itemId,
    });
  }
}
